module.exports = __webpack_public_path__ + "img/syzw.b76da9b7.jpg";